import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-paint',
  templateUrl: './icon-paint.component.html',
  styleUrls: ['./icon-paint.component.scss']
})
export class IconPaintComponent implements OnInit {

  @Input() cssClass = 'icon--18';
  
  constructor() { }

  ngOnInit() {
  }

}
